import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bt-icon bt-icon--sm" }
const _hoisted_2 = { class: "dialog-custom__header" }
const _hoisted_3 = { class: "dialog-custom__title mb-0" }
const _hoisted_4 = { class: "form-custom dialog-custom__content" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = {
  class: "p-field-label",
  for: "room-name"
}
const _hoisted_9 = {
  for: "room-name",
  class: "fs-13 label-error"
}
const _hoisted_10 = { class: "p-field mr-3 mb-4" }
const _hoisted_11 = { class: "p-field-label mb-4" }
const _hoisted_12 = { class: "bt-icon text-gray" }
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { class: "dialog-custom__footer" }
const _hoisted_15 = {
  key: 0,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDialogVisible = $event)),
    showHeader: false,
    modal: true,
    onHide: _ctx.doHideDialog,
    class: "dialog-custom dialog-configure-room"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "close",
        onClick: _ctx.handleHideDialog,
        class: "dialog-custom__close-button p-button-text"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_1, [
            _createVNode(_component_InlineSvgScoped, {
              src: require(`@/assets/images/icons/icon-close.svg`)
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode("header", _hoisted_2, [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.RoomParameters")), 1)
      ]),
      _createVNode(_component_ElScrollbar, { class: "el-scrollbar--v-only" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Name")), 1),
                  _createVNode(_component_InputText, {
                    id: "room-name",
                    type: "text",
                    class: ["w-100", { 'input-error': !_ctx.isValidName }],
                    modelValue: _ctx.theRoom.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.theRoom.name = $event))
                  }, null, 8, ["class", "modelValue"]),
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.invalidNameReason), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.TypeUpper")), 1),
              _createVNode(_component_SelectButton, {
                modelValue: _ctx.theRoom.type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.theRoom.type = $event)),
                options: _ctx.roomTypes,
                optionLabel: "type",
                optionValue: "type",
                class: "p-selectbutton--blocks p-2",
                style: {"--cols":"6"}
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode("span", _hoisted_12, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                        require(`@/assets/images/icons/${_ctx.getRoomIcon(
                                            slotProps.option.type
                                        )}.svg`)
                                    
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("p", _hoisted_13, _toDisplayString(slotProps.option.label), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode("footer", _hoisted_14, [
        _createVNode(_component_Button, {
          label: _ctx.$t('AppResource.Save'),
          onClick: _ctx.doSubmit,
          disabled: _ctx.lockSave,
          class: "p-button-rounded p-button-raised p-button--m"
        }, null, 8, ["label", "onClick", "disabled"])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}